import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import SweetAlert from "react-bootstrap-sweetalert";

// core components
import Wizard from "../../components/Wizard/Wizard.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Table from "../../components/Table/Table.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardIcon from "../../components/Card/CardIcon.jsx";
import CardBody from "../../components/Card/CardBody.jsx";

import Step1 from "./ConfiguratorSteps/Step1.jsx";
import Step2 from "./ConfiguratorSteps/Step2.jsx";
import Step3 from "./ConfiguratorSteps/Step3.jsx";
import Step4 from "./ConfiguratorSteps/Step4.jsx";
import Step5 from "./ConfiguratorSteps/Step5.jsx";
import Step6 from "./ConfiguratorSteps/Step6.jsx";
import Step7 from "./ConfiguratorSteps/Step7.jsx";

import sweetAlertStyle from "../../assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

import Assignment from "@material-ui/icons/Assignment";

import { cardTitle } from "../../assets/jss/material-dashboard-pro-react.jsx";

const style = {
	customCardContentClass: {
		paddingLeft: "0",
		paddingRight: "0"
	},
	cardIconTitle: {
		...cardTitle,
		marginTop: "15px",
		marginBottom: "0px"
	},
	...sweetAlertStyle
};

class ConfiguratorView extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			list: [],
			contact: {
				company: "",
				department: "",
				firstName: "",
				lastName: "",
				streetNo: "",
				zipCode: "",
				city: "",
				country: "",
				phone: "",
				email: ""
			},
			lang: "en",
			response: "",
			hint: null
		}
	}

	hideHint() {
		this.setState({
			hint: null
		});
	}

	showHint(wizard) {
		this.setState({
			hint: (
				<SweetAlert
					note
					style={{ display: "block", marginTop: "-100px" }}
					title="Hint"
					showCancel
					confirmBtnText="Skip to contact"
					cancelBtnText="Continue"
					onConfirm={() => {
						this.hideHint();
						wizard.jump();
					}}
					onCancel={() => this.hideHint()}
					confirmBtnCssClass={
						this.props.classes.button + " " + this.props.classes.success
					}
					cancelBtnCssClass={
						this.props.classes.button + " " + this.props.classes.success
					}
				>
					You can jump directly to contact data
					if you don't like to specify a laser source and optics.
				</SweetAlert>
			)
		});
	}

	sendEmail(){
		this.postApi('/api/email', this.state)
			.then(res => res.json())
			.then((result) => {
				this.setState({ response: result },() => {
					this.props.history.push({
						pathname: '/en/thankyou',
						state: {
							pdfUrl: this.state.response.pdfUrl
						}
					})
				})
			})
			.catch(err => console.log(err));
	}

	callApi = async (endPoint, m) => {
		const fetchConfig = {
			method: m
		};
		const response = await fetch(endPoint, fetchConfig);
		const body = await response.json();
		if (response.status !== 200) throw Error(body.message);
		return body;
	};

	postApi(url, data){
		return fetch(url, {
			body: JSON.stringify(data), // must match 'Content-Type' header
			cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
			credentials: 'same-origin', // include, same-origin, *omit
			headers: {
				'user-agent': 'Mozilla/4.0 MDN Example',
				'content-type': 'application/json'
			},
			method: 'POST', // *GET, POST, PUT, DELETE, etc.
			mode: 'cors', // no-cors, cors, *same-origin
			redirect: 'follow', // manual, *follow, error
			referrer: 'no-referrer', // *client, no-referrer
		})
	};

	renderList(wizard,forward = true){
		var tmp = [], uniqeStates = [];

		wizard.state.allStates.forEach((element) => {
			uniqeStates[Object.keys(element)] = element;
		});

		uniqeStates.map((v,index) => {
			if (v[index] !== undefined &&
					v[index].selected !== undefined &&
					v[index].selected !== "" &&
					v[index].description !== undefined ) {

				let tableLineContent = [
					<span>
						{v[index].selected} <br />
						<small>{v[index].description}</small>
					</span>
				];

				tmp.push(tableLineContent);

			}
		});

		this.setState({
			list: tmp
		});

	}

	render() {
		const { classes } = this.props;
		return (
			<div>
			{this.state.hint}
			<GridContainer justify="center">
				<GridItem xs={12} sm={9}>
					<Wizard
						validate
						finishButtonClick={(wizard)=>{
							let uniqeStates = [];
							wizard.state.allStates.forEach((element) => {
								uniqeStates[Object.keys(element)] = element;
							});
							this.setState({
								allStates: uniqeStates,
								contact: wizard.contact.state
							}, () => {
								console.log(this.state);
								this.sendEmail();
							})
						}}
						previousButtonClick={(wizard)=>{
							this.renderList(wizard);
						}}
						nextButtonClick={(wizard)=>{
							if (wizard.state.currentStep == 4) {
								this.showHint(wizard);
							}
							this.renderList(wizard);
						}}
						steps={[
							{ stepName: "Process", stepComponent: Step1, stepId: "0" },
							{ stepName: "Work piece", stepComponent: Step2, stepId: "1" },
							{ stepName: "Automatization", stepComponent: Step3, stepId: "2" },
							{ stepName: "Features", stepComponent: Step4, stepId: "3" },
							{ stepName: "Laser source", stepComponent: Step5, stepId: "4" },
							{ stepName: "Process optics", stepComponent: Step6, stepId: "5" },
							{ stepName: "Contact", stepComponent: Step7, stepId: "contact" }
						]}
						color="warning"
						nextButtonText= "Next"
						previousButtonText= "Previous"
						nextButtonClasses="warning"
						finishButtonText = "Send enquiry"
					/>
				</GridItem>
				<GridItem xs={12} sm={3}>
				<Card>
					<CardHeader color="warning" icon>
						<CardIcon color="warning">
							<Assignment />
						</CardIcon>
						<h4 className={classes.cardIconTitle}>Your configuration</h4>
					</CardHeader>
					<CardBody>
						<Table
							tableHeaderColor="warning"
							// tableHead={["Konfiguration"]}
							tableData={ this.state.list }
							coloredColls={[3]}
							colorsColls={["primary"]}
							/>
					</CardBody>
				</Card>
				</GridItem>
			</GridContainer>
			</div>
		);
	}
}

export default withStyles(style)(ConfiguratorView);



// WEBPACK FOOTER //
// ./src/views/ConfiguratorEN/Configurator.jsx